import { useEffect } from 'react';

const GoogleAnalytics = ({ id }) => {
    useEffect(() => {
        const scriptTag = document.createElement("script");
        scriptTag.async = true;
        scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
        document.head.appendChild(scriptTag);

        const scriptInline = document.createElement("script");
        scriptInline.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${id}');
        `;
        document.head.appendChild(scriptInline);

        return () => {
            document.head.removeChild(scriptTag);
            document.head.removeChild(scriptInline);
        };
    }, [id]);

    return null;
};

export default GoogleAnalytics;
